import styled from 'styled-components';

import type {
  MenuItemProps,
  MenuItemComponent,
} from '@n3/react-autocomplete';

export const MenuItem: MenuItemComponent = styled.div<MenuItemProps>(({
  $isHighlighted,

  theme: {
    colors,
    fonts,
    indents,
  },
}) => ({
  ...fonts.DEFAULT,
  display: 'block',
  boxSizing: 'border-box',
  paddingTop: 4,
  paddingBottom: 4,
  paddingLeft: indents.INDENT_2,
  paddingRight: indents.INDENT_2,
  color: colors.NEUTRAL_DEFAULT,
  cursor: 'pointer',
  backgroundColor: $isHighlighted ? colors.ACTION_BACKGROUND : undefined,
}));
